import {sx} from './sx'
import {Box, Paper, Stack, Typography} from "@mui/material";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {ClearIcon, RefreshIcon} from "@ui/icons/icons";
import {FC, ReactNode} from "react";
import {useTranslation} from "react-i18next";
import ButtonSidebar from "@ui/buttons/buttonCustom/ButtonSidebar";
import {ERROR_COLOR} from "@view/constants/colors";

interface IProps {
    message?: string,
    variant?: 'overlay',
    children?: ReactNode,
    onRefresh?: () => void
    onResetError?: () => void,
    resetErrorButtonMessage?: string,
}

const ErrorBlock: FC<IProps> = ({
                                    message,
                                    variant = 'overlay',
                                    children,
                                    onRefresh,
                                    onResetError,
                                    resetErrorButtonMessage,
                                }) => {

    const {t} = useTranslation()

    if (variant === 'overlay') {
        return (
            <>
                <Box sx={sx.overlay}/>
                <Paper
                    elevation={3}
                    sx={sx.inner}
                >
                    {children ? children : <Stack
                        direction={'row'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        gap={1}
                    >
                        <Typography
                            variant={'body2'}
                        >
                            {message || 'щось пішло не так...'}
                        </Typography>

                        {onRefresh && <IconButtonCustom
                            onClick={onRefresh}
                            color={'#b6b6d6'}
                            tooltip={'Спробувати ще раз'}
                        >
                            <RefreshIcon/>
                        </IconButtonCustom>}


                        {onResetError && <>{
                            resetErrorButtonMessage ?
                                <ButtonSidebar
                                    onClick={onResetError}
                                    label={resetErrorButtonMessage}
                                    color={ERROR_COLOR}
                                    icon={<ClearIcon/>}
                                /> :
                                <IconButtonCustom
                                    onClick={onResetError}
                                    color={'#b6b6d6'}
                                    tooltip={t('base.close')}
                                >
                                    <ClearIcon/>
                                </IconButtonCustom>
                        }</>}

                    </Stack>}
                </Paper>
            </>
        );
    }
};

export default ErrorBlock;